// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";

var dropIndicatorClass = "col-drop-before";

var draggingClass = "col-drag-dragging";

function parseMinWidth(raw) {
  if (raw === undefined) {
    return 60;
  }
  var n = Belt_Int.fromString(raw);
  if (n !== undefined) {
    return Math.max(1, n);
  } else {
    return 60;
  }
}

function clampColumnWidth(startWidth, delta, minW) {
  return Math.max(minW, startWidth + delta);
}

function effectiveColumnWidth(saved, minW, existingStyleWidth) {
  if (saved !== undefined) {
    return Math.max(minW, saved);
  } else if (existingStyleWidth !== undefined && existingStyleWidth > 0.0 && !Number.isNaN(existingStyleWidth)) {
    return existingStyleWidth;
  } else {
    return minW;
  }
}

function totalTableMinWidth(widths) {
  return Belt_Array.reduce(widths, 0.0, (function (acc, w) {
                return acc + w;
              }));
}

function exceedsDragThreshold(dx, dy, thresholdOpt) {
  var threshold = thresholdOpt !== undefined ? thresholdOpt : 5;
  if (Math.abs(dx) > threshold) {
    return true;
  } else {
    return Math.abs(dy) > threshold;
  }
}

function reorderColumnKeys(currentOrder, draggedKey, dropIndex) {
  var draggedIndex = currentOrder.indexOf(draggedKey);
  if (draggedIndex === -1 || draggedIndex === dropIndex) {
    return ;
  }
  var without = Belt_Array.keep(currentOrder, (function (key) {
          return key !== draggedKey;
        }));
  var insertIdx = dropIndex > draggedIndex ? dropIndex - 1 | 0 : dropIndex;
  var before = without.slice(0, insertIdx);
  var after = without.slice(insertIdx);
  return before.concat([draggedKey].concat(after));
}

var savedWidths = {};

function parseStyleWidthPx(style) {
  var raw = style.width;
  if (raw === "") {
    return ;
  }
  var n = parseFloat(raw);
  if (Number.isNaN(n) || n <= 0.0) {
    return ;
  } else {
    return n;
  }
}

function getThMinWidth(th) {
  return parseMinWidth(Caml_option.nullable_to_opt(th.getAttribute("data-min-width")));
}

function getReorderableColumnKeys(table) {
  var row = table.querySelector("thead tr:first-child");
  if (row == null) {
    return [];
  } else {
    return Belt_Array.keepMap(Array.from(row.querySelectorAll("th")).slice(1), (function (cell) {
                  var value = cell.getAttribute("data-col-key");
                  if (!(value == null)) {
                    return value;
                  }
                  
                }));
  }
}

function applyWidths(table) {
  var ths = Array.from(table.querySelectorAll("thead th[data-col-key]"));
  var widths = Belt_Array.map(ths, (function (th) {
          var value = th.getAttribute("data-col-key");
          var key = (value == null) ? "" : value;
          var minW = getThMinWidth(th);
          var saved = key === "" ? undefined : Js_dict.get(savedWidths, key);
          var w = effectiveColumnWidth(saved, minW, parseStyleWidthPx(th.style));
          th.style.width = String(w) + "px";
          th.style.minWidth = String(w) + "px";
          return w;
        }));
  var total = totalTableMinWidth(widths);
  if (total > 0.0) {
    table.style.minWidth = String(total) + "px";
    table.style.width = "100%";
    return ;
  }
  
}

function clearDropIndicator(table) {
  Array.from(table.querySelectorAll("thead th." + dropIndicatorClass)).forEach(function (th) {
        DomEl$GameDataCore.removeClass(th, dropIndicatorClass);
      });
  Array.from(table.querySelectorAll("thead th." + draggingClass)).forEach(function (th) {
        DomEl$GameDataCore.removeClass(th, draggingClass);
      });
}

function thUnderPoint(table, clientX) {
  var row = table.querySelector("thead tr:first-child");
  if (row == null) {
    return ;
  }
  var ths = Array.from(row.querySelectorAll("th"));
  return Caml_option.undefined_to_opt(ths.find(function (th) {
                  var rect = th.getBoundingClientRect();
                  if (clientX >= rect.left) {
                    return clientX <= rect.right;
                  } else {
                    return false;
                  }
                }));
}

function attachResizeHandles(table) {
  Array.from(table.querySelectorAll("thead th")).forEach(function (th) {
        var match = th.querySelector(".col-resize-handle");
        if (!(match == null)) {
          return ;
        }
        var handle = document.createElement("div");
        DomEl$GameDataCore.addClass(handle, "col-resize-handle");
        th.style.position = "relative";
        th.appendChild(handle);
        var startX = {
          contents: 0
        };
        var startWidth = {
          contents: 0
        };
        var onMouseMove = {
          contents: (function (_event) {
              
            })
        };
        var onMouseUp = {
          contents: (function (_event) {
              
            })
        };
        onMouseMove.contents = (function ($$event) {
            var delta = $$event.clientX - startX.contents;
            var minW = getThMinWidth(th);
            var newWidth = clampColumnWidth(startWidth.contents, delta, minW);
            th.style.width = String(newWidth) + "px";
            th.style.minWidth = String(newWidth) + "px";
            var key = th.getAttribute("data-col-key");
            if (!(key == null)) {
              savedWidths[key] = newWidth;
            }
            applyWidths(table);
          });
        onMouseUp.contents = (function (_event) {
            document.removeEventListener("mousemove", onMouseMove.contents);
            document.removeEventListener("mouseup", onMouseUp.contents);
            var bodyStyle = document.body.style;
            bodyStyle.cursor = "";
            bodyStyle.userSelect = "";
            table.style.cursor = "";
          });
        var stopInteraction = function ($$event) {
          $$event.preventDefault();
          $$event.stopPropagation();
        };
        DomEl$GameDataCore.on(handle, "mousedown", (function ($$event) {
                stopInteraction($$event);
                startX.contents = $$event.clientX;
                startWidth.contents = th.offsetWidth;
                var bodyStyle = document.body.style;
                bodyStyle.cursor = "col-resize";
                bodyStyle.userSelect = "none";
                table.style.cursor = "col-resize";
                document.addEventListener("mousemove", onMouseMove.contents);
                document.addEventListener("mouseup", onMouseUp.contents);
              }));
        DomEl$GameDataCore.on(handle, "click", stopInteraction);
      });
}

function attachDragHandles(table, pushEvent) {
  var theadRow = table.querySelector("thead tr:first-child");
  if (theadRow == null) {
    return ;
  }
  var ths = Array.from(theadRow.querySelectorAll("th"));
  if (ths.length >= 2) {
    ths.slice(1).forEach(function (th) {
          var key = th.getAttribute("data-col-key");
          if (key == null) {
            return ;
          }
          var match = th.querySelector(".col-drag-handle");
          if (!(match == null)) {
            return ;
          }
          var handle = document.createElement("span");
          DomEl$GameDataCore.addClass(handle, "col-drag-handle");
          handle.setAttribute("aria-label", "Drag to reorder column");
          handle.textContent = "⋮⋮";
          var stop = function ($$event) {
            $$event.preventDefault();
            $$event.stopPropagation();
          };
          DomEl$GameDataCore.on(handle, "mousedown", stop);
          DomEl$GameDataCore.on(handle, "click", stop);
          DomEl$GameDataCore.on(handle, "mousedown", (function ($$event) {
                  stop($$event);
                  var startX = $$event.clientX;
                  var startY = $$event.clientY;
                  var didMove = {
                    contents: false
                  };
                  var dropTh = {
                    contents: undefined
                  };
                  var onMouseMove = {
                    contents: (function (_event) {
                        
                      })
                  };
                  var onMouseUp = {
                    contents: (function (_event) {
                        
                      })
                  };
                  onMouseMove.contents = (function (moveEvent) {
                      var dx = Math.abs(moveEvent.clientX - startX);
                      var dy = Math.abs(moveEvent.clientY - startY);
                      if (!didMove.contents && exceedsDragThreshold(dx, dy, undefined)) {
                        didMove.contents = true;
                        DomEl$GameDataCore.addClass(th, draggingClass);
                        var bodyStyle = document.body.style;
                        bodyStyle.cursor = "grabbing";
                        bodyStyle.userSelect = "none";
                      }
                      if (!didMove.contents) {
                        return ;
                      }
                      clearDropIndicator(table);
                      var over = thUnderPoint(table, moveEvent.clientX);
                      if (over === undefined) {
                        dropTh.contents = undefined;
                        return ;
                      }
                      var over$1 = Caml_option.valFromOption(over);
                      if (over$1.cellIndex !== 0 && over$1 !== th) {
                        DomEl$GameDataCore.addClass(over$1, dropIndicatorClass);
                        dropTh.contents = Caml_option.some(over$1);
                      } else {
                        dropTh.contents = undefined;
                      }
                    });
                  onMouseUp.contents = (function (_upEvent) {
                      document.removeEventListener("mousemove", onMouseMove.contents);
                      document.removeEventListener("mouseup", onMouseUp.contents);
                      var bodyStyle = document.body.style;
                      bodyStyle.cursor = "";
                      bodyStyle.userSelect = "";
                      DomEl$GameDataCore.removeClass(th, draggingClass);
                      clearDropIndicator(table);
                      var match = didMove.contents;
                      var match$1 = dropTh.contents;
                      if (!match) {
                        return ;
                      }
                      if (match$1 === undefined) {
                        return ;
                      }
                      var target = Caml_option.valFromOption(match$1);
                      if (target === th) {
                        return ;
                      }
                      var currentOrder = getReorderableColumnKeys(table);
                      var dropIndex = target.cellIndex - 1 | 0;
                      var newOrder = reorderColumnKeys(currentOrder, key, dropIndex);
                      if (newOrder !== undefined) {
                        return pushEvent("restore-columns", {
                                    columns: newOrder
                                  });
                      }
                      
                    });
                  document.addEventListener("mousemove", onMouseMove.contents);
                  document.addEventListener("mouseup", onMouseUp.contents);
                }));
          var child = th.firstChild;
          if (child == null) {
            th.appendChild(handle);
          } else {
            th.insertBefore(handle, child);
          }
        });
    return ;
  }
  
}

function mountTable(table, pushEvent) {
  applyWidths(table);
  attachResizeHandles(table);
  attachDragHandles(table, pushEvent);
}

function mounted() {
  var self = this ;
  mountTable(self.el, (function ($$event, payload) {
          self.pushEvent($$event, payload);
        }));
}

function updated() {
  var self = this ;
  var table = self.el;
  applyWidths(table);
  attachResizeHandles(table);
  clearDropIndicator(table);
  attachDragHandles(table, (function ($$event, payload) {
          self.pushEvent($$event, payload);
        }));
}

var resizableColumns = {
  mounted: mounted,
  updated: updated
};

var defaultMinWidth = 60;

var dragThresholdPx = 5;

export {
  defaultMinWidth ,
  dragThresholdPx ,
  dropIndicatorClass ,
  draggingClass ,
  parseMinWidth ,
  clampColumnWidth ,
  effectiveColumnWidth ,
  totalTableMinWidth ,
  exceedsDragThreshold ,
  reorderColumnKeys ,
  savedWidths ,
  parseStyleWidthPx ,
  getThMinWidth ,
  getReorderableColumnKeys ,
  applyWidths ,
  clearDropIndicator ,
  thUnderPoint ,
  attachResizeHandles ,
  attachDragHandles ,
  mountTable ,
  mounted ,
  updated ,
  resizableColumns ,
}
/* mounted Not a pure module */
